/**
 * 由于暂时其实仅仅只支持bybit插件的ton
 * 所以这个connector 只是为了 连接 bybit插件的ton地址
 *
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { TON_CHAIN_ID } from '../../../utils/constants';
import { AbstractWalletConnector } from '../../core/AbstractWalletConnector';
import { ChainTypes } from '../../core/types';
import { addListener, isBrowser } from '../../misc';

export class TonConnector extends AbstractWalletConnector {
  readonly chainType = ChainTypes.TON as const;

  private _provider?: any;
  public get provider() {
    return this._provider;
  }

  private _getProvider: () => Promise<any>;

  constructor(name: string, _provider: unknown) {
    super(name);
    this.chainId = TON_CHAIN_ID;
    this._getProvider = async () => {
      const provider = typeof _provider === 'function' ? await _provider() : _provider;
      if (!provider) {
        return;
      }
      if (typeof provider === 'string') {
        return isBrowser ? window[provider] : undefined;
      }
      if (typeof provider === 'object') {
        return provider;
      }
      return;
    };
  }

  private _unSubscribeProvider: (() => void) | undefined;
  private _subscribeProvider(provider: any) {
    this._unSubscribeProvider?.();
    if (!provider.on) {
      return;
    }

    // 暂时Ton 的事件不了解先写在这儿
    const removeAccountChange = addListener(provider, 'accountChanged', (publicKey: any) => {
      //   this._address =
    });
    const removeDisconnect = addListener(provider, 'disconnect', () => {
      this.publicKey = undefined;
      this._address = undefined;
    });

    const removeOnConnect = addListener(provider, 'connect', async () => {
      //   没这个事件
    });

    const unSubscribe = () => {
      removeAccountChange();
      removeOnConnect();
      removeDisconnect();
      this._unSubscribeProvider = undefined;
    };
    this._unSubscribeProvider = unSubscribe;
  }

  // ton 的connect 是支持 option的，暂时现在不实际处理ton的connect
  async connect(_recovery = false, _options: any) {
    const provider = await this.getProvider();
    if (!provider) {
      throw new Error(`${this.name} provider not found or not ready`);
    }
    const { publicKey, address } = await provider.connect();
    this.address = address;
    this.publicKey = publicKey;
    return this.address;
  }

  async disconnect() {
    this.address = undefined;
    this.publicKey = undefined;
    const provider = (await this.getProvider()) as any;
    if (typeof provider?.disconnect === 'function') {
      await provider?.disconnect();
    }
    return;
  }

  async getProvider(force = false): Promise<any> {
    if (!this._provider || force) {
      const eipProvider = await this._getProvider();
      if (eipProvider) {
        this._provider = eipProvider;
        this._subscribeProvider(eipProvider);
      } else {
        this._provider = undefined;
      }
    }
    return this._provider;
  }

  async isAvailable() {
    const provider = await this.getProvider();
    return Boolean(provider);
  }
}
